import React from 'react'
import cx from 'classnames'

import s from './Overlay.scss'


export type OverlayProps = {
  className?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const Overlay: React.FunctionComponent<OverlayProps> = ({ children, className, onClick }) => (
  <div className={cx(s.overlay, className)} onClick={onClick}>
    {children}
  </div>
)


export default Overlay
